import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { computed } from 'mobx';
import { StructPropBuilder } from '@logio/common-be-fe';
import AbstractFilterFormStore from '../../../shared/forms/AbstractFilterFormStore';
export var QuerryFormFilter = function QuerryFormFilter(limit, offset) {
  _classCallCheck(this, QuerryFormFilter);

  this.limit = limit;
  this.offset = offset;
};
export var QuerryFormStore =
/*#__PURE__*/
function (_AbstractFilterFormSt) {
  _inherits(QuerryFormStore, _AbstractFilterFormSt);

  function QuerryFormStore(initValues) {
    var _this;

    _classCallCheck(this, QuerryFormStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(QuerryFormStore).call(this));
    _this.initValues = initValues;
    /**
     * @inheritDoc
     */

    _this.defaultValues = new QuerryFormFilter(10, 0);
    /**
     * @inheritDoc
     */

    _this.builder = new StructPropBuilder('querry');

    _get(_getPrototypeOf(QuerryFormStore.prototype), "setInitialValues", _assertThisInitialized(_this)).call(_assertThisInitialized(_this), initValues || _this.defaultValues);

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(QuerryFormStore, [{
    key: "getFormDescriptions",
    get: function get() {
      return {
        limit: this.builder.opt(this.builder.str('limit')),
        offset: this.builder.opt(this.builder.str('offset'))
      };
    }
  }]);

  return QuerryFormStore;
}(AbstractFilterFormStore);

__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], QuerryFormStore.prototype, "getFormDescriptions", null);